import {
  GET_QA,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialQna = {
  qna: [],
  qnaCount: 0,
  page: 1,
  search: "",
  courseId: "",
  QandAId: "",
  sortby: "",
  orderby: "desc",
};

const qnaReducer = (state = initialQna, action) => {
  switch (action.type) {
    case GET_QA:
      return {
        ...state,
        qna: action.payload.q_and_a,
        qnaCount: action.payload.total,
        QandAId: action.payload.QandAId,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };

    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    default:
      return state;
  }
};

export default qnaReducer;
